export class UserModel {
    public id: number;
    public uuid: string;
    public firstname: string;
    public lastname: string;
    public email: string;
    public user_type: string;
    public status: number;
    public is_verified: number;
    public created_at: string;
    public updated_at: string;
    public full_name: string;
    public user_role: string;

    constructor(obj: any) {
        this.id = obj.id ? obj.id : 0;
        this.uuid = obj.uuid ? obj.uuid : '';
        this.firstname = obj.firstname ? obj.firstname : '';
        this.lastname = obj.lastname ? obj.lastname : '';
        this.email = obj.email ? obj.email : '';
        this.user_type = obj.user_type ? obj.user_type : '';
        this.status = obj.status ? obj.status : 0;
        this.is_verified = obj.is_verified ? obj.is_verified : 0;
        this.full_name = obj.full_name ? obj.full_name : '';
        this.user_role = obj.user_role ? obj.user_role : '';
        this.created_at = obj.created_at ? obj.created_at : '';
        this.updated_at = obj.updated_at ? obj.updated_at : '';
    }
}
